import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import ExchangeNft from '../../components/Gamification/ExchangeNft'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

const AutoRowColumn = styled(RowColumn)`
  height: 543px;
`

const Info = styled.div`
  color: ${({ theme }) => theme.bsText7};
  width: 432px;
  height: auto;
  flex: 1;
  margin-top: 25px;
  overflow-y: scroll;
  padding: 16px 30px;
  border-radius: 20px;
  background: ${({ theme }) => theme.bsBg2};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  `};
`

const TextLink = styled.a`
  margin-top: 20px;
  font-size: 14px;
  color: inherit;
`


export default function MuskUsmLand () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/mul.png'}/>
        <AutoRowColumn>
          <ExchangeNft type={NFTTYPE.MUSKUSMLAND} />
          <Info className={location.pathname.indexOf('gamification/car') > -1 ? activeClassName : ''}>
            <Text fontSize={14}>This is a unique opportunity to acquire very scarce <Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700}  style={{display: 'inline'}}>Land</Text> property in Doge State (The USM Metaverse) + a chance to possess <Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700}  style={{display: 'inline'}}>MBP</Text> (the most valuable NFT in BSC).</Text>
            <br/>
            <Text fontSize={14}>Musk USM LAND: Sticker Name — <Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700} style={{display: 'inline'}}>MML</Text></Text>
            <br/>
            <Text fontSize={14}>The total supply in this release is: <Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700} style={{display: 'inline'}}>10000</Text> Land NFTs + 99 MPB Avatars</Text>
            <Text fontSize={14} marginTop={20}>1. 99 MPB Avatar to claim 99 <Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700} style={{display: 'inline'}}>MPB NFTs</Text>. The 90 Avatar NFTs have serials ranging from #5500 to #5599(except #5555). They can claim one real MPB NFT with corresponding serials #5500— #5599 (except #5555).</Text>
            <Text fontSize={14} marginTop={20}>2. <Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700} style={{display: 'inline'}}>10,000</Text> parcels of Land in Doge State, the United States of Mars. (Parcel #20000–#29999)</Text>
            <Text fontSize={14} marginTop={20}>3. Price: 1 $bnb/each</Text>
            <Text fontSize={14} marginTop={20}>Each parcel of Doge Land offered in this release is programmatically generated with a unique serial number from 20000–29999 . Each Land is unique and rare, and the amount of land is scarce.</Text>
            <Text fontSize={14} marginTop={20}><Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700} style={{display: 'inline'}}>SPECIAL</Text>: All Land NFT in this release <Text fontSize={14} fontFamily={'Baloo Da'} fontWeight={700} style={{display: 'inline'}}>can farm Land</Text> on <TextLink href={'https://www.radiocaca.com'} target={'_blank'}>www.radiocaca.com.</TextLink></Text>
            <Text fontSize={14} marginTop={20}>3 parcels of Lands can farm one more Land in 3 months.</Text>
            <Text fontSize={14} marginTop={20}>1 Land can farm one more Land in 12 months</Text>
            <Text fontSize={14} marginTop={20}>10 parcels of Lands can farm one rare Metamon in 3 months.</Text>
          </Info>
        </AutoRowColumn>
      </Main>
    </SoccerMain>
  )
}